import React, { Component } from "react";
import { connect } from "react-redux";
import { setTaskTypeListPageSize, setTaskTypeListFilterTitle } from "Actions";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import debounce from "lodash.debounce";
import _ from "i18n";

class TaskTypeFilter extends Component {
  constructor(props) {
    super(props);
    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 100);
  }
  handleSearchInputChange(word) {
    if (word.length > 2 || word.length === 0) {
      this.props.dispatch(setTaskTypeListFilterTitle(word));
    }
  }

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    // TODO
  };

  handleListPageSizeChange = selected => {
    this.props.dispatch(setTaskTypeListPageSize(selected));
  };

  render() {
    let {
      customAddOn,
      taskTypesFilter,
      pageSize,
      nbResult,
      label,
      marginLeft,
      fetching
    } = this.props;
    let filters = [];

    return (
      <div className="row align-center medium-12">
        <div className="medium-12">
          <TTPFilterHorizontalBar
            button={this.props.button}
            filters={filters}
            pageSize={pageSize}
            customAddOn={customAddOn}
            searchInputValue={taskTypesFilter.label}
            searchPlaceholder="Search by name"
            handleResetFilter={this.handleResetFilter}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            handleListPageSizeChange={this.handleListPageSizeChange}
            filterFormIsVisible={this.filterFormIsVisible}
            cssClass="medium-12"
            nbResult={nbResult}
            label={_(label)}
            marginLeft={marginLeft}
            fetching={fetching}
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  taskTypesFilter: state.taskTypes.list.filter,
  lng: state.params.lng
});

export default connect(mapStateToProps)(TaskTypeFilter);



// WEBPACK FOOTER //
// ./src/components/TaskTypeFilter/TaskTypeFilter.js